export default class SampleLanguageWriteDTO {

    public id: string | undefined;
    public salesTerm: string | undefined;
    public languageId: number | undefined;
    public sampleId: number | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.salesTerm = data['salesTerm'] || undefined;
        this.languageId = data['languageId'] || undefined;
        this.sampleId = data['sampleId'] || undefined;
    }
}